import { Box, BoxProps } from '@wrisk/ui-components'
import { isNil } from 'lodash-es'
import React, { FunctionComponent } from 'react'

import {
  Specification,
  toVehicleEngine,
  toVehicleEnginePower,
  toVehicleFuelDescription,
} from '../../../../domain'
import {
  tEntries,
  tFormats,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { AttributeRow } from './AttributeRow'

interface VehicleDetailsProps extends BoxProps {
  vehicle: Specification
}

export const VehicleDetails: FunctionComponent<VehicleDetailsProps> = ({
  vehicle,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const imported = isNil(vehicle.imported)
    ? undefined
    : vehicle.imported
    ? t(tEntries('boolean.yes'))
    : t(tEntries('boolean.no'))

  const grossWeight = isNil(vehicle.grossWeight)
    ? undefined
    : t(tFormats('number.standard'), {
        amount: vehicle.grossWeight,
      })

  return (
    <Box width={1} {...props}>
      <AttributeRow name='Manufactured' value={vehicle.year.toString()} />
      <AttributeRow name='Fuel' value={toVehicleFuelDescription(vehicle)} />
      <AttributeRow name='Electric type' value={vehicle.electricVehicleType} />
      <AttributeRow name='Body style' value={vehicle.bodyStyle} />
      <AttributeRow name='Transmission' value={vehicle.transmission} />
      <AttributeRow name='Drive train' value={vehicle.driveTrain} />
      <AttributeRow name='Engine' value={toVehicleEngine(vehicle)} />
      <AttributeRow name='Performance' value={toVehicleEnginePower(vehicle)} />
      <AttributeRow name='Imported' value={imported} />
      <AttributeRow name='Gross weight' value={grossWeight} />
    </Box>
  )
}
